import { styled } from '@stitches/react';
import { useMemo } from 'react';
import { useElements, useScene } from '../../hooks';

export const LinkElement = ({ elementID }: { elementID: string }) => {
  const scene = useScene();
  const [element] = useElements({ id: elementID });

  const Link = useMemo(
    () => styled('a', element?.props?.class),
    [element?.props?.class]
  );

  return (
    <Link
      element-type="link"
      id={element?.id}
      {...scene.launcherStateProps}
      href={element?.props?.href}
      onDragStart={(e: MouseEvent) => e.preventDefault()}
      onClick={(e: MouseEvent) => e.preventDefault()}
    >
      {element?.props?.text}
    </Link>
  );
};
